import { useEffect, useState } from 'react';

interface UseDelayedRenderOptions {
  delay?: number;
  mobileOnly?: boolean;
}

export const useDelayedRender = (
  options: UseDelayedRenderOptions = {
    delay: 1000,
  }
) => {
  const { delay = 1000, mobileOnly = true } = options;
  const [shouldRender, setShouldRender] = useState(false);

  // @ts-ignore
  useEffect(() => {
    // If it's not mobile-only OR if it is mobile, apply the delay
    const isMobile = window.innerHeight > window.innerWidth;
    if (!mobileOnly || isMobile) {
      const timer = setTimeout(() => {
        setShouldRender(true);
      }, delay);

      return () => clearTimeout(timer);
    } else {
      // On desktop, render immediately
      setShouldRender(true);
    }
  }, [delay, mobileOnly]);

  return shouldRender;
};
